// socketReducer.js
import {
  SOCKET_CONNECT,
  SOCKET_DISCONNECT,
  SOCKET_MESSAGE_RECEIVED,
  SOCKET_NOTIFICATION_RECEIVED,
} from '../ActionType/socketActionType';

const initialState = {
  connected: false,
  messages: '',
  notification:'',
};

export const socketReducer = (state = initialState, action) => {
    const {  type, payload } = action;

  switch (type) {
    case SOCKET_CONNECT:
      return { ...state, connected: true };

    case SOCKET_DISCONNECT:
      return { ...state, connected: false };

    case SOCKET_MESSAGE_RECEIVED:
      return {
        ...state,
        messages: payload,
      };

    case SOCKET_NOTIFICATION_RECEIVED:
        return {
            ...state,
            notification: payload
        }

    default:
      return state;
  }
};
